import React, {PropTypes} from 'react';
import {BootstrapTable,TableHeaderColumn} from 'react-bootstrap-table';

class LeaveBalanceTable extends React.Component {

    constructor() {
      super();
    }
    componentDidMount()
    {}

    render() {
        return (
          <div>
            <BootstrapTable
              pagination
              containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
              headerStyle={{
                borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
                , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
              }}
              tableStyle={{marginBottom: '10%', borderStyle: 'solid'}}

              maxHeight={"500px"}  data={this.props.data} exportCSV={true}>
              <TableHeaderColumn dataField="applicantId" isKey={true} hidden={true}/>
              <TableHeaderColumn dataField="empId" filter={{type: 'TextFilter',placeHolder: 'Employee Id'}} isKey={false}>Employee Id</TableHeaderColumn>
              <TableHeaderColumn dataField="empName" filter={{type: 'TextFilter',placeHolder: 'Employee Name'}}>Employee Name </TableHeaderColumn>
              <TableHeaderColumn dataSort={true}
                                 filter={{type: 'SelectFilter',options: {EL: "EL",'OL':'OL','MrL':'MrL','ML':'ML','CL':'CL','LOP':'LOP','PC':'PC'},placeHolder: 'Leave Type'}}
                                 dataField="leaveType">Leave Type</TableHeaderColumn>
              <TableHeaderColumn dataField="noOfDays" dataSort={true} >Days</TableHeaderColumn>
              <TableHeaderColumn dataField="paycut" dataSort={true} >Paycut</TableHeaderColumn>
              <TableHeaderColumn dataSort={true} dataField="startDate" filter={{type: 'TextFilter',placeHolder: 'Start Date'}}>Start Date</TableHeaderColumn>
              <TableHeaderColumn dataSort={true} dataField="endDate" filter={{type: 'TextFilter',placeHolder: 'End Date'}}>End Date</TableHeaderColumn>
              <TableHeaderColumn  dataField="leaveStatus"
                                  filter={{type: 'SelectFilter',options: {'applied':'Applied','approved':'Approved','rejected':'Rejected','cancel':'Cancel'},placeHolder: 'Status'}}>Leave Status</TableHeaderColumn>
              <TableHeaderColumn dataSort={true} dataField="appliedOn" filter={{type: 'TextFilter',placeHolder: 'Applied Date'}}>Applied Date</TableHeaderColumn>

              </BootstrapTable>
          </div>
        );
    }
}

LeaveBalanceTable.propTypes = {};

export default LeaveBalanceTable;





/** WEBPACK FOOTER **
 ** ./src/feature/leave/LeaveBalance/LeaveTransTable.js
 **/